export const minGoodDaysLeft = 23;
export const maxGoodDaysLeft = 37;
export const maxDaysForActiveGoal = 365;
